import Reveal from '@/components/base/Reveal';
import { entries } from '@/mocks/home';

export default function EntrySection() {
  return (
    <section id="entry" className="w-full bg-background-100 py-16 md:py-20">
      <div className="w-full px-4 md:px-8">
        <Reveal className="flex flex-col md:flex-row md:items-end justify-between gap-4 border-b border-background-300 pb-6">
          <div>
            <span className="text-xs md:text-sm tracking-[0.2em] text-primary-600">ENTRY · 资源入口</span>
            <h3 className="mt-3 font-heading text-2xl md:text-3xl font-bold text-foreground-950">先选一个入口，再往下看</h3>
          </div>
          <p className="text-sm text-foreground-600 max-w-md leading-6">
            六个入口覆盖从识别、自查到求助的主要环节，按你的处境选择最贴近的一项即可。
          </p>
        </Reveal>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {entries.map((item, index) => (
            <Reveal key={item.title} delay={index * 60}>
              <a
                href={item.href}
                className="group flex flex-col h-full rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 p-5 md:p-6 transition-colors cursor-pointer"
              >
                <div className="flex items-start justify-between">
                  <span className="w-11 h-11 flex items-center justify-center rounded-md bg-primary-100 text-primary-700">
                    <i className={`${item.icon} text-xl`}></i>
                  </span>
                  <span className="text-[11px] px-2 py-1 rounded-full bg-secondary-100 text-secondary-900 tracking-wide">
                    {item.tag}
                  </span>
                </div>
                <h4 className="mt-4 font-heading text-lg font-bold text-foreground-950">{item.title}</h4>
                <p className="mt-2 text-sm leading-6 text-foreground-600 flex-1">{item.desc}</p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 group-hover:gap-2.5 transition-all">
                  进入查看
                  <i className="ri-arrow-right-line"></i>
                </span>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}